import React, { useState } from "react";
import { Image, ScrollView } from "react-native";
import type { Meta, StoryObj } from "@storybook/react";
import Modal from "../../components/Modal";
import Button from "../../components/Button";
import Text from "../../components/Text";
import VStack from "../../ui_atoms/VStack";
import SelectField from "../../components/SelectField";
import { SelectItemType } from "../../components/select/SelectChooser";

const ModalStory = () => {
    const [textModalVisible, setTextModalVisible] = useState(false);
    const [imageModalVisible, setImageModalVisible] = useState(false);
    const [selectModalVisible, setSelectModalVisible] = useState(false);
    const [longContentModalVisible, setLongContentModalVisible] = useState(false);
    const [modalStackVisible, setModalStackVisible] = useState(false);
    const [modalStackVisible2, setModalStackVisible2] = useState(false);

    const [selectValue, setSelectValue] = useState<SelectItemType<string>>();

    return (
        <VStack gap="1" style={{ padding: 20, width: "100%" }}>
            <Button
                label="Modal avec texte"
                onPress={() => setTextModalVisible(true)}
                buttonMode="primary"
            />
            <Modal visible={textModalVisible} onClose={() => setTextModalVisible(false)}>
                <VStack gap="1" style={{ padding: 20 }}>
                    <Text style={{ fontSize: 24, fontWeight: "bold", textAlign: "center" }}>
                        Titre de la modal
                    </Text>
                    <Text style={{ fontSize: 16, textAlign: "center" }}>
                        Ceci est un contenu textuel simple dans une modal. Vous pouvez y mettre du
                        texte explicatif.
                    </Text>
                    <Button
                        label="Fermer"
                        onPress={() => setTextModalVisible(false)}
                        buttonMode="outlined"
                    />
                </VStack>
            </Modal>

            <Button
                label="Modal avec image"
                onPress={() => setImageModalVisible(true)}
                buttonMode="secondary"
            />
            <Modal visible={imageModalVisible} onClose={() => setImageModalVisible(false)}>
                <VStack gap="1" style={{ padding: 20, alignItems: "center" }}>
                    <Text style={{ fontSize: 20, fontWeight: "bold" }}>Image exemple</Text>
                    <Image
                        source={{ uri: "https://picsum.photos/300/200" }}
                        style={{ width: 300, height: 200, borderRadius: 8 }}
                    />
                    <Text style={{ fontSize: 14, color: "#666", textAlign: "center" }}>
                        Une image aléatoire depuis Picsum
                    </Text>
                    <Button
                        label="Fermer"
                        onPress={() => setImageModalVisible(false)}
                        buttonMode="outlined"
                    />
                </VStack>
            </Modal>

            <Button
                label="Modal avec SelectField"
                onPress={() => setSelectModalVisible(true)}
                buttonMode="tertiary"
            />
            <Modal visible={selectModalVisible} onClose={() => setSelectModalVisible(false)}>
                <VStack gap="1" style={{ padding: 20 }}>
                    <Text style={{ fontSize: 20, fontWeight: "bold", textAlign: "center" }}>
                        Sélectionnez une option
                    </Text>
                    <SelectField
                        style={{ alignSelf: "stretch" }}
                        value={selectValue?.value}
                        data={[
                            { label: "Option 1", value: "opt1" },
                            { label: "Option 2", value: "opt2" },
                            { label: "Option 3", value: "opt3" },
                            { label: "Option 4 - avec un texte plus long", value: "opt4" },
                        ]}
                        label="Choisissez une option"
                        searchPlaceholder="Rechercher..."
                        onSelect={setSelectValue}
                    />
                    <Text style={{ fontSize: 14, color: "#666" }}>
                        Valeur sélectionnée: {selectValue?.label ?? "Aucune"}
                    </Text>
                    <Button
                        label="Confirmer"
                        onPress={() => setSelectModalVisible(false)}
                        buttonMode="primary"
                    />
                </VStack>
            </Modal>

            <Button
                label="Modal avec contenu long"
                onPress={() => setLongContentModalVisible(true)}
                buttonMode="outlined"
            />
            <Modal
                visible={longContentModalVisible}
                onClose={() => setLongContentModalVisible(false)}
            >
                <ScrollView>
                    <VStack gap="0.5" style={{ padding: 20 }}>
                        <Text style={{ fontSize: 20, fontWeight: "bold" }}>Contenu scrollable</Text>
                        {Array.from({ length: 20 }).map((_, i) => (
                            <Text key={i} style={{ fontSize: 14 }}>
                                Paragraphe {i + 1}: Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit. Sed do eiusmod tempor incididunt ut labore et
                                dolore magna aliqua.
                            </Text>
                        ))}
                        <Button
                            label="Fermer"
                            onPress={() => setLongContentModalVisible(false)}
                            buttonMode="outlined"
                        />
                    </VStack>
                </ScrollView>
            </Modal>

            <Button
                label="Modal in modal"
                onPress={() => setModalStackVisible(true)}
                buttonMode="outlined"
            />
            <Modal visible={modalStackVisible} onClose={() => setModalStackVisible(false)}>
                <VStack gap="0.5" style={{ padding: 20 }}>
                    <Text style={{ fontSize: 20, fontWeight: "bold" }}>
                        This is the first modal
                    </Text>
                    <Button
                        label="Open the second modal!"
                        onPress={() => setModalStackVisible2(true)}
                        buttonMode="outlined"
                    />
                </VStack>
                <Modal visible={modalStackVisible2} onClose={() => setModalStackVisible2(false)}>
                    <VStack gap="0.5" style={{ padding: 20 }}>
                        <Text style={{ fontSize: 20, fontWeight: "bold" }}>
                            This is the SECOND modal
                        </Text>
                    </VStack>
                </Modal>
            </Modal>
        </VStack>
    );
};

const meta = {
    title: "Components/Modal",
    component: ModalStory,
} satisfies Meta<typeof ModalStory>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {},
};
